import React from "react";
import Parse from "parse";
import linkedInImage from "../linkedIn.png";

function LinkedInOauth() {
  const onclick = async () => {
    window.location.reload();
  };
  return (
    <div>
      <br></br>
      <a href="https://www.linkedin.com/oauth/v2/authorization?response_type=code&state=323EZD45&scope=r_liteprofile%20r_emailaddress&client_id=78iz9k6vajbwyr&redirect_uri=https%3A%2F%2Fbsgwahtks7.execute-api.eu-west-3.amazonaws.com%2Fdefault%2FlinkedinSocialConnect">
        <img
          src={linkedInImage}
          style={{ maxWidth: "180px", cursor: "pointer" }}
        ></img>
      </a>
      <br></br>
      {/* <button onClick={onclick} >the burron</button> */}
    </div>
  );
}

export default LinkedInOauth;
